// extracted by mini-css-extract-plugin
module.exports = {"text-btn":"text-btn__23DX8","textBtn":"text-btn__23DX8"};